import React from 'react'

const GiletVibrant = () => {
  return (
    <div>
      <h1>Malentendants</h1>
      <p>
        10 gilets vibrants sont mis à disposition pour les concerts du vendredi
        soir 26 et samedi soir 27. Les réservations <span className='bold'>OBLIGATOIRES</span>{' '}
        sont à faire sur cette adresse :{' '}
        <a href="mailto:clavalette@laposte.net">clavalette@laposte.net</a>. Le
        prêt sera fait en échange d'une pièce d'identité.
      </p>
    </div>
  )
}

export default GiletVibrant